import React from "react"
import classnames from "classnames"
import styles from "./VehicleNotFoundPage.less"
import { P, Space, AlertIcon, Section } from 'AtomicComponents'
import {
  Image,
  HeroContent
} from 'AtomicContainers'
import componentParser from "AtomicUtils/componentParser"

class VehicleNotFoundPage extends React.Component {

  render() {
    const { heading, description, vehicles, ctas = [] } = this.props
    return (
      <Section horizontalPadding>
        { (heading || description) &&
          <HeroContent
            heading={heading}
            description={description}
            Icon={AlertIcon}
            iconColor={'red'}
          />
        }
        <div
          className={classnames({
            [styles.VehicleNotFoundPage]: true
          })}
        >
          {
            vehicles && vehicles.map(vehicle => (
              <div
                className={classnames({
                  [styles.VehicleNotFoundPageVehicle]: true
                })}
              >
                <Image src={vehicle.imageSrc} height={100} />
                <Space />
                <P>{vehicle.ctas && componentParser(vehicle.ctas)}</P>
              </div>
            ))
          }
        </div>
        {ctas && componentParser(ctas)}
        <Space />
        <Space />
        <Space />
      </Section>
    )
  }
}


export default VehicleNotFoundPage



// WEBPACK FOOTER //
// ./src/AtomicContainers/VehicleNotFoundPage/VehicleNotFoundPage.jsx